import { Http } from '@/lib/http';

export class GeneralLoanSettingService extends Http {
  constructor() {
    super();
    this.endpoint = 'loan-pro/settings/general-loan-settings';
  }

  fetchGeneralLoanSettings() {
    return this.httpClient().get(this.endpoint);
  }

  updateGeneralLoanSettings(id, updates) {
    return this.httpClient().patch(`${this.endpoint}/${id}`, updates);
  }

  createPaymentFrequency() {
    return this.httpClient().post(this.endpoint);
  }

  deletePaymentFrequency(id) {
    return this, this.httpClient().delete(`${this.endpoint}/${id}`);
  }
}
